<template>
  <ContentWrap>
    <div class="page-head">
      <div><h2>代理运营中心</h2><p>钱包、商品授权、模板、广告与团队成员统一管理</p></div>
      <div
        ><el-button @click="loadAll">刷新</el-button
        ><el-button type="primary" @click="openRecharge">钱包充值</el-button
        ><el-button type="warning" @click="withdrawVisible = true">申请提现</el-button></div
      >
    </div>
    <el-row :gutter="16" class="mb-16px">
      <el-col :span="8"
        ><el-card shadow="never"
          ><span>可用余额</span><strong>{{ money(wallet?.availableBalance) }}</strong></el-card
        ></el-col
      >
      <el-col :span="8"
        ><el-card shadow="never"
          ><span>冻结余额</span><strong>{{ money(wallet?.frozenBalance) }}</strong></el-card
        ></el-col
      >
      <el-col :span="8"
        ><el-card shadow="never"
          ><span>待结算</span><strong>{{ money(wallet?.pendingBalance) }}</strong></el-card
        ></el-col
      >
    </el-row>
    <el-tabs v-model="tab">
      <el-tab-pane label="可购商品" name="catalog"
        ><el-table v-loading="loading" :data="catalog"
          ><el-table-column prop="name" label="商品" /><el-table-column
            prop="itemType"
            label="类型"
          /><el-table-column prop="version" label="版本" /><el-table-column label="年费"
            ><template #default="{ row }">{{ money(row.priceYear) }}</template></el-table-column
          ><el-table-column label="操作" width="100"
            ><template #default="{ row }"
              ><el-button link type="primary" @click="openPurchase(row)">购买</el-button></template
            ></el-table-column
          ></el-table
        ></el-tab-pane
      >
      <el-tab-pane label="商品订单" name="orders"
        ><el-table :data="orders"
          ><el-table-column prop="itemName" label="商品" /><el-table-column
            prop="tenantId"
            label="租户ID" /><el-table-column prop="billingCycle" label="周期" /><el-table-column
            label="金额"
            ><template #default="{ row }">{{ money(row.amount) }}</template></el-table-column
          ><el-table-column prop="createTime" label="购买时间" /></el-table
      ></el-tab-pane>
      <el-tab-pane label="模板授权" name="templates"
        ><el-table :data="templates"
          ><el-table-column prop="tenantId" label="租户ID" /><el-table-column
            prop="catalogItemId"
            label="模板ID" /><el-table-column prop="version" label="当前版本" /><el-table-column
            prop="rollbackVersion"
            label="回滚版本" /><el-table-column prop="changeRemark" label="最近变更" /></el-table
      ></el-tab-pane>
      <el-tab-pane label="广告" name="ads"
        ><el-table :data="ads"
          ><el-table-column prop="title" label="标题" /><el-table-column
            prop="placement"
            label="广告位"
          /><el-table-column prop="scopeType" label="范围" /><el-table-column label="状态"
            ><template #default="{ row }"
              ><el-tag
                :type="row.status === 1 ? 'success' : row.status === 2 ? 'danger' : 'warning'"
                >{{ ['待审核', '已通过', '已驳回'][row.status] }}</el-tag
              ></template
            ></el-table-column
          ></el-table
        ></el-tab-pane
      >
      <el-tab-pane label="团队成员" name="members"
        ><div class="mb-12px"
          ><el-button type="primary" @click="memberVisible = true">添加成员</el-button></div
        ><el-table :data="members"
          ><el-table-column prop="userId" label="用户" /><el-table-column
            prop="memberRole"
            label="角色"
          /><el-table-column label="状态"
            ><template #default="{ row }">{{
              row.status === 1 ? '启用' : '停用'
            }}</template></el-table-column
          ></el-table
        ></el-tab-pane
      >
      <el-tab-pane label="提现记录" name="withdrawals"
        ><el-table :data="withdrawals"
          ><el-table-column label="金额"
            ><template #default="{ row }">{{ money(row.amount) }}</template></el-table-column
          ><el-table-column prop="accountName" label="收款人" /><el-table-column
            prop="accountNo"
            label="账号" /><el-table-column label="状态"
            ><template #default="{ row }">{{
              withdrawalStatus(row.status)
            }}</template></el-table-column
          ><el-table-column prop="auditRemark" label="审核说明" /></el-table
      ></el-tab-pane>
      <el-tab-pane label="钱包流水" name="transactions"
        ><el-table :data="transactions"
          ><el-table-column prop="bizType" label="业务" /><el-table-column label="金额"
            ><template #default="{ row }"
              ><span :class="row.changeAmount >= 0 ? 'income' : 'expense'">{{
                money(row.changeAmount)
              }}</span></template
            ></el-table-column
          ><el-table-column label="余额"
            ><template #default="{ row }">{{ money(row.balanceAfter) }}</template></el-table-column
          ><el-table-column prop="remark" label="说明" /><el-table-column
            prop="createTime"
            label="时间" /></el-table
      ></el-tab-pane>
    </el-tabs>
  </ContentWrap>

  <el-dialog v-model="purchaseVisible" title="购买并授权" width="440px"
    ><el-form :model="purchase" label-width="90px"
      ><el-form-item label="商品">{{ selected?.name }}</el-form-item
      ><el-form-item label="租户ID"
        ><el-input-number v-model="purchase.tenantId" :min="1" class="!w-100%" /></el-form-item
      ><el-form-item label="计费周期"
        ><el-select v-model="purchase.billingCycle" class="!w-100%"
          ><el-option label="月" value="MONTH" /><el-option
            label="季度"
            value="QUARTER" /><el-option label="年" value="YEAR" /><el-option
            label="永久"
            value="LIFETIME" /></el-select></el-form-item></el-form
    ><template #footer
      ><el-button @click="purchaseVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submitPurchase"
        >确认购买</el-button
      ></template
    ></el-dialog
  >
  <el-dialog v-model="withdrawVisible" title="申请提现" width="440px"
    ><el-form :model="withdraw" label-width="90px"
      ><el-form-item label="金额（元）"
        ><el-input-number
          v-model="withdraw.yuan"
          :min="0.01"
          :precision="2"
          class="!w-100%" /></el-form-item
      ><el-form-item label="收款人"><el-input v-model="withdraw.accountName" /></el-form-item
      ><el-form-item label="收款账号"
        ><el-input v-model="withdraw.accountNo" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="withdrawVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submitWithdrawal"
        >提交</el-button
      ></template
    ></el-dialog
  >
  <el-dialog v-model="memberVisible" title="添加代理成员" width="440px"
    ><el-form :model="member" label-width="90px"
      ><el-form-item label="用户"
        ><el-select v-model="member.userId" class="!w-full" filterable clearable placeholder="请选择用户">
          <el-option v-for="u in staffOptions" :key="u.value" :label="u.label" :value="u.value" />
        </el-select></el-form-item
      ><el-form-item label="角色"
        ><el-select v-model="member.memberRole" class="!w-100%"
          ><el-option label="运营" value="OPERATOR" /><el-option
            label="销售"
            value="SALES" /><el-option label="财务" value="FINANCE" /><el-option
            label="技术支持"
            value="SUPPORT" /></el-select></el-form-item></el-form
    ><template #footer
      ><el-button @click="memberVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submitMember"
        >保存</el-button
      ></template
    ></el-dialog
  >
</template>

<script setup lang="ts">
import { ElMessage, ElMessageBox } from 'element-plus'
import * as Api from '@/api/system/agent'
defineOptions({ name: 'AgentCenter' })
const { staffOptions, staffMap, loadStaffs } = useStaff()
const tab = ref('catalog')
const loading = ref(false)
const submitting = ref(false)
const wallet = ref<Api.AgentWallet>()
const catalog = ref<Api.AgentCatalogItem[]>([])
const orders = ref<any[]>([])
const templates = ref<any[]>([])
const ads = ref<any[]>([])
const members = ref<any[]>([])
const withdrawals = ref<Api.AgentWithdrawal[]>([])
const transactions = ref<any[]>([])
const purchaseVisible = ref(false)
const withdrawVisible = ref(false)
const memberVisible = ref(false)
const selected = ref<Api.AgentCatalogItem>()
const purchase = reactive({
  tenantId: 1,
  billingCycle: 'YEAR' as 'MONTH' | 'QUARTER' | 'YEAR' | 'LIFETIME'
})
const withdraw = reactive({ yuan: 0, accountName: '', accountNo: '' })
const member = reactive({ userId: 1, memberRole: 'OPERATOR', enabled: true })
const money = (cents?: number) => `¥${((cents || 0) / 100).toFixed(2)}`
const withdrawalStatus = (s: number) => ['待审核', '待打款', '已驳回', '已打款'][s] || '未知'
const loadAll = async () => {
  loading.value = true
  try {
    const result = await Promise.allSettled([
      Api.getMyWallet(),
      Api.getAgentCatalog(),
      Api.getMyAgentCatalogOrders(),
      Api.getMyTemplateAuthorizations(),
      Api.getMyAdvertisements(),
      Api.getMyAgentMembers(),
      Api.getMyAgentWithdrawals(),
      Api.getMyWalletTransactions()
    ])
    const values = result.map((x) => (x.status === 'fulfilled' ? x.value : undefined))
    ;[
      wallet.value,
      catalog.value,
      orders.value,
      templates.value,
      ads.value,
      members.value,
      withdrawals.value,
      transactions.value
    ] = values as any
  } finally {
    loading.value = false
  }
}
const openRecharge = async () => {
  try {
    const { value } = await ElMessageBox.prompt('请输入充值金额（元）', '钱包充值', {
      inputPattern: /^\d+(\.\d{1,2})?$/,
      inputErrorMessage: '请输入正确金额'
    })
    const order = await Api.createAgentRecharge({ amount: Math.round(Number(value) * 100) })
    ElMessage.success(`充值订单已创建，支付单号：${order.payOrderId}`)
  } catch {
    /* user cancelled */
  }
}
const openPurchase = (row: Api.AgentCatalogItem) => {
  selected.value = row
  purchaseVisible.value = true
}
const submitPurchase = async () => {
  if (!selected.value?.id) return
  submitting.value = true
  try {
    await Api.purchaseAgentCatalogItem({
      tenantId: purchase.tenantId,
      catalogItemId: selected.value.id,
      billingCycle: purchase.billingCycle
    })
    ElMessage.success('购买成功，授权已生效')
    purchaseVisible.value = false
    await loadAll()
  } finally {
    submitting.value = false
  }
}
const submitWithdrawal = async () => {
  if (!withdraw.yuan || !withdraw.accountName || !withdraw.accountNo) {
    ElMessage.warning('请完整填写提现信息')
    return
  }
  submitting.value = true
  try {
    await Api.createAgentWithdrawal({
      amount: Math.round(withdraw.yuan * 100),
      accountName: withdraw.accountName,
      accountNo: withdraw.accountNo
    })
    ElMessage.success('提现申请已提交')
    withdrawVisible.value = false
    await loadAll()
  } finally {
    submitting.value = false
  }
}
const submitMember = async () => {
  submitting.value = true
  try {
    await Api.saveAgentMember(member)
    ElMessage.success('成员已保存')
    memberVisible.value = false
    await loadAll()
  } finally {
    submitting.value = false
  }
}
onMounted(() => { loadStaffs(); loadAll() })
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-head h2 {
  margin: 0 0 6px;
}
.page-head p {
  margin: 0;
  color: var(--el-text-color-secondary);
}
.el-card span {
  color: var(--el-text-color-secondary);
}
.el-card strong {
  display: block;
  margin-top: 8px;
  font-size: 26px;
}
.income {
  color: var(--el-color-success);
}
.expense {
  color: var(--el-color-danger);
}
</style>
